"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailKeypad = exports.NumberKeypad = exports.Keypad = exports.keypadActions = void 0;
const React = require("react");
const Button_1 = require("../../atoms/Button");
const numberPadOptions_1 = require("./helpers/numberPadOptions");
const emailPadOptions_1 = require("./helpers/emailPadOptions");
var keypadActions_1 = require("./helpers/keypadActions");
Object.defineProperty(exports, "keypadActions", { enumerable: true, get: function () { return keypadActions_1.keypadActions; } });
const styles = require("./styles.scss");
const Keypad = ({ options, onKeySelect }) => (React.createElement("div", { className: styles.keypad, "data-test": "keypad" },
    React.createElement("div", { className: styles.keypad_3 }, options.map((option, index) => {
        return (React.createElement("div", { key: index, "data-test": "key", "data-index": index, "data-key": option.value },
            React.createElement(Button_1.AltButton, { className: styles.numberSelector, onClick: () => {
                    onKeySelect(option);
                }, isBlock: true }, option.label)));
    }))));
exports.Keypad = Keypad;
const NumberKeypad = props => (React.createElement(exports.Keypad, Object.assign({ options: numberPadOptions_1.numberPadOptions }, props)));
exports.NumberKeypad = NumberKeypad;
const EmailKeypad = props => (React.createElement(exports.Keypad, Object.assign({ options: emailPadOptions_1.emailPadOptions }, props)));
exports.EmailKeypad = EmailKeypad;
//# sourceMappingURL=index.js.map